class FitObject {
  constructor(elem, elemItem, aspect_w, aspect_h) {
    this._e;
    this._ei;
    this._e_height;
    this._e_width;
    this._e_aspect;
    aspect_w = aspect_w == null ? 16 : aspect_w;
    aspect_h = aspect_h == null ? 9 : aspect_h;
    this._ei_aspect = aspect_w / aspect_h;

    this.init = () => {
      this._e = elem;
      this._ei = elemItem;
      this._e_height = this._e.clientHeight;
      this._e_width = this._e.clientWidth;
      this._e_aspect = this._e_width / this._e_height;
      this.calc();
    };

    this.init();

  }
  
  reset(aspect_w, aspect_h){
    aspect_w = aspect_w == null ? 16 : aspect_w;
    aspect_h = aspect_h == null ? 9 : aspect_h;
    this._ei_aspect = aspect_w / aspect_h;
  }
  

  calc() {
    let child = this._ei.children;
    for (let i = 0; i < child.length; i++) {
      TweenMax.set(child[i], {
        x: 0
      });
    }
    if (this._e_aspect >= this._ei_aspect) { //横長
      this._ei.style.width = `${this._e_width}px`;
      this._ei.style.height = `${ 1 / this._ei_aspect * this._e_width }px`;
    } else {
      let w = this._ei_aspect * this._e_height
      this._ei.style.height = `${this._e_height}px`;
      this._ei.style.width = `${w}px`;
      for (let i = 0; i < child.length; i++) {
        TweenMax.set(child[i], {
          x: 0.5 * (this._e_width - w)
        });
      }
    }
  }

}